

import React, { useState, useEffect } from 'react';
import styles from "./HomeLandingPagePureCSS.module.css"
import ModernNavbar from "../components/Navbar/ModernNavBarPureCSS"
import LandingPageNavBar from '../components/Navbar/LandingPageNavBar';

// Dummy components to avoid breaking the page.
// In a real scenario, these would be properly implemented or imported.
const Button = ({ children, ...props }) => <button {...props}>{children}</button>
const Card = ({ children, ...props }) => <div {...props}>{children}</div>
const Badge = ({ children, ...props }) => <div {...props}>{children}</div>
const Avatar = ({ children, ...props }) => <div {...props}>{children}</div>
const AvatarImage = (props) => <img {...props} />
const AvatarFallback = ({ children, ...props }) => <div {...props}>{children}</div>

// Placeholder icons
const Search = () => <span>🔍</span>
const MapPin = () => <span>📍</span>
const Star = () => <span>*</span>
const Users = () => <span>👥</span>
const CheckCircle = () => <span>✓</span>
const Play = () => <span>▶</span>
const Clock = () => <span>🕒</span>
const Home = () => <span>🏠</span>
const Wrench = () => <span>🔧</span>
const Paintbrush = () => <span>🖌️</span>
const Zap = () => <span>⚡</span>
const Heart = () => <span>❤️</span>
const Phone = () => <span>📞</span>
const MessageSquare = () => <span>💬</span>

const HomeLandingPagePureCSS = () => {
  const [searchQuery, setSearchQuery] = useState("")
  const [location, setLocation] = useState("")
  const [isVisible, setIsVisible] = useState({})

  const popularServices = [
    { name: "Plumbing", icon: Wrench, count: "2,847 professionals" },
    { name: "Electrical", icon: Zap, count: "1,923 professionals" },
    { name: "Painting", icon: Paintbrush, count: "3,156 professionals" },
    { name: "Renovation", icon: Home, count: "1,678 professionals" },
  ]

  const featuredBusinesses = [
    {
      id: 1,
      name: "Elite Home Services",
      rating: 4.9,
      reviews: 847,
      category: "Home Renovation",
      image: "/placeholder.svg?height=200&width=300",
      verified: true,
      responseTime: "< 2 hours",
      completedJobs: 1247,
    },
    {
      id: 2,
      name: "Quick Fix Plumbing",
      rating: 4.8,
      reviews: 623,
      category: "Emergency Plumbing",
      image: "/placeholder.svg?height=200&width=300",
      verified: true,
      responseTime: "< 1 hour",
      completedJobs: 892,
    },
    {
      id: 3,
      name: "Modern Kitchens Co.",
      rating: 4.9,
      reviews: 1156,
      category: "Kitchen Design",
      image: "/placeholder.svg?height=200&width=300",
      verified: true,
      responseTime: "< 3 hours",
      completedJobs: 567,
    },
  ]

  const testimonials = [
    {
      name: "Sarah Mitchell",
      role: "Homeowner",
      content:
        "Found the perfect contractor for my kitchen renovation. The whole process was seamless and the quality exceeded my expectations!",
      rating: 5,
      image: "/placeholder.svg?height=60&width=60",
    },
    {
      name: "David Chen",
      role: "Property Manager",
      content:
        "Build Start has become my go-to platform for finding reliable contractors. The verification process gives me confidence in every hire.",
      rating: 5,
      image: "/placeholder.svg?height=60&width=60",
    },
    {
      name: "Emma Rodriguez",
      role: "First-time Buyer",
      content:
        "As a new homeowner, Build Start helped me find trustworthy professionals for all my home improvement needs. Highly recommended!",
      rating: 5,
      image: "/placeholder.svg?height=60&width=60",
    },
  ]

  const stats = [
    { number: "50,000+", label: "Verified Professionals", icon: Users },
    { number: "2M+", label: "Jobs Completed", icon: CheckCircle },
    { number: "4.9/5", label: "Average Rating", icon: Star },
    { number: "24/7", label: "Customer Support", icon: Clock },
  ]

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible((prev) => ({ ...prev, [entry.target.id]: true }))
          }
        })
      },
      { threshold: 0.1 },
    )

    document.querySelectorAll("[data-animate]").forEach((el) => {
      observer.observe(el)
    })

    return () => observer.disconnect()
  }, [])

  const handleSearch = (e) => {
    e.preventDefault()
    // Handle search logic here
    console.log("Searching for:", searchQuery, "in", location)
  }

  return (
    <div className={styles.homeLandingPage}>
      <LandingPageNavBar />

      {/* Hero Section */}
      <section className={styles.heroSection}>
        <div className={styles.heroBackground}>
          <div className={styles.heroGradient}></div>
          <div className={styles.heroPattern}></div>
        </div>

        <div className={styles.heroContent}>
          <div className={styles.heroText}>
            <h1 className={styles.heroTitle}>
              Find <span className={styles.heroHighlight}>Trusted Local</span>
              <br />
              Professionals for Every Job
            </h1>
            <p className={styles.heroSubtitle}>
              Connect with verified professional, get instant quotes, and connect with any service for your needs. Thousands of professionals ready to help you today.
            </p>
          </div>

          <div className={styles.heroSearch}>
            <form onSubmit={handleSearch} className={styles.searchForm}>
              <div className={styles.searchInputs}>
                <div className={styles.searchInputGroup}>
                  <Search className={styles.searchIcon} />
                  <input
                    type="text"
                    placeholder="What service do you need?"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className={styles.searchInput}
                  />
                </div>
                <div className={styles.searchInputGroup}>
                  <MapPin className={styles.searchIcon} />
                  <input
                    type="text"
                    placeholder="Enter your postcode"
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                    className={styles.searchInput}
                  />
                </div>
                <Button type="submit" className={styles.searchButton}>
                  <Search />
                  Find Professionals
                </Button>
              </div>
            </form>

            <div className={styles.popularServices}>
              <span className={styles.popularLabel}>Popular services:</span>
              <div className={styles.popularTags}>
                {popularServices.map((service, index) => (
                  <button key={index} className={styles.popularTag}>
                    <service.icon />
                    {service.name}
                  </button>
                ))}
              </div>
            </div>
          </div>

{/*
          <div className={styles.heroStats}>
            {stats.map((stat, index) => (
              <div key={index} className={styles.heroStat}>
                <stat.icon className={styles.heroStatIcon} />
                <div className={styles.heroStatContent}>
                  <div className={styles.heroStatNumber}>{stat.number}</div>
                  <div className={styles.heroStatLabel}>{stat.label}</div>
                </div>
              </div>
            ))}
          </div>
*/}


        </div>
      </section>

      {/* How It Works Section */}
      <section className={styles.howItWorksSection} id="how-it-works" data-animate>
        <div className={styles.container}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>How Build Start Works</h2>
            <p className={styles.sectionSubtitle}>Get your project done in three simple steps</p>
          </div>

          <div className={styles.stepsGrid}>
            <div className={styles.stepCard}>
              <div className={styles.stepNumber}>1</div>
              <div className={styles.stepIcon}>
                <Search />
              </div>
              <h3 className={styles.stepTitle}>Search & Compare</h3>
              <p className={styles.stepDescription}>
                Tell us what you need and we'll show you verified professionals in your area with reviews and ratings.
              </p>
            </div>

            <div className={styles.stepCard}>
              <div className={styles.stepNumber}>2</div>
              <div className={styles.stepIcon}>
                <MessageSquare />
              </div>
              <h3 className={styles.stepTitle}>Get Quotes</h3>
              <p className={styles.stepDescription}>
                Receive multiple quotes from interested professionals. Compare prices, timelines, and expertise.
              </p>
            </div>

            <div className={styles.stepCard}>
              <div className={styles.stepNumber}>3</div>
              <div className={styles.stepIcon}>
                <CheckCircle />
              </div>
              <h3 className={styles.stepTitle}>Hire with Confidence</h3>
              <p className={styles.stepDescription}>
                Choose the best professional for your job and get it done right. Leave a review to help others.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Businesses Section */}
      <section className={styles.featuredSection} id="featured" data-animate>
        <div className={styles.container}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>Top-Rated Professionals</h2>
            <p className={styles.sectionSubtitle}>Discover highly-rated professionals in your area</p>
          </div>

          <div className={styles.featuredGrid}>
            {featuredBusinesses.map((business) => (
              <Card key={business.id} className={styles.featuredBusinessCard}>
                <div className={styles.businessImageContainer}>
                  <img src={business.image || "/placeholder.svg"} alt={business.name} className={styles.businessImage} />
                  <div className={styles.businessBadges}>
                    {business.verified && (
                      <Badge className={styles.verifiedBadge}>
                        <CheckCircle />
                        Verified
                      </Badge>
                    )}
                  </div>
                  <button className={styles.favoriteButton}>
                    <Heart />
                  </button>
                </div>

                <div className={styles.businessContent}>
                  <div className={styles.businessHeader}>
                    <h3 className={styles.businessName}>{business.name}</h3>
                    <div className={styles.businessRating}>
                      <div className={styles.ratingStars}>
                        {[...Array(5)].map((_, i) => (
                          <Star
                            key={i}
                            className={`${styles.ratingStar} ${i < Math.floor(business.rating) ? styles.ratingStarFilled : ""}`}
                          />
                        ))}
                      </div>
                      <span className={styles.ratingText}>
                        {business.rating} ({business.reviews} reviews)
                      </span>
                    </div>
                  </div>

                  <p className={styles.businessCategory}>{business.category}</p>

                  <div className={styles.businessStats}>
                    <div className={styles.businessStat}>
                      <Clock />
                      <span>Responds {business.responseTime}</span>
                    </div>
                    <div className={styles.businessStat}>
                      <CheckCircle />
                      <span>{business.completedJobs} jobs completed</span>
                    </div>
                  </div>

                  <div className={styles.businessActions}>
                    <Button className={styles.contactButton}>
                      <Phone />
                      Get Quote
                    </Button>
                    <Button variant="outline" className={`${styles.viewButton} bg-transparent`}>
                      View Profile
                    </Button>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className={styles.testimonialsSection} id="testimonials" data-animate>
        <div className={styles.container}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>What Our Customers Say</h2>
            <p className={styles.sectionSubtitle}>
              Join thousands of satisfied homeowners who found their perfect professional
            </p>
          </div>

          <div className={styles.testimonialsGrid}>
            {testimonials.map((testimonial, index) => (
              <Card key={index} className={styles.testimonialCard}>
                <div className={styles.testimonialRating}>
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className={styles.testimonialStar} />
                  ))}
                </div>
                <p className={styles.testimonialContent}>"{testimonial.content}"</p>
                <div className={styles.testimonialAuthor}>
                  <Avatar className={styles.testimonialAvatar}>
                    <AvatarImage src={testimonial.image || "/placeholder.svg"} />
                    <AvatarFallback>{testimonial.name.charAt(0)}</AvatarFallback>
                  </Avatar>
                  <div className={styles.testimonialInfo}>
                    <div className={styles.testimonialName}>{testimonial.name}</div>
                    <div className={styles.testimonialRole}>{testimonial.role}</div>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className={styles.ctaSection}>
        <div className={styles.container}>
          <div className={styles.ctaContent}>
            <h2 className={styles.ctaTitle}>Ready to Start Your Project?</h2>
            <p className={styles.ctaSubtitle}>
              Join over 2 million homeowners who have found their perfect professional on Build Start
            </p>
            <div className={styles.ctaButtons}>
              <Button size="lg" className={styles.ctaPrimary}>
                <Search />
                Find Professionals Now
              </Button>
              <Button size="lg" variant="outline" className={`${styles.ctaSecondary} bg-transparent`}>
                <Play />
                Watch How It Works
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className={styles.footer}>
        <div className={styles.container}>
          <div className={styles.footerContent}>
            <div className={styles.footerSection}>
              <div className={styles.footerLogo}>
                <Home className={styles.footerLogoIcon} />
                <span className={styles.footerLogoText}>Build Start</span>
              </div>
              <p className={styles.footerDescription}>Connecting homeowners with trusted local professionals since 2020.</p>
            </div>

            <div className={styles.footerSection}>
              <h4 className={styles.footerTitle}>For Homeowners</h4>
              <ul className={styles.footerLinks}>
                <li>
                  <a href="#" className={styles.footerLink}>
                    Find Professionals
                  </a>
                </li>
                <li>
                  <a href="#" className={styles.footerLink}>
                    How It Works
                  </a>
                </li>
                <li>
                  <a href="#" className={styles.footerLink}>
                    Customer Reviews
                  </a>
                </li>
                <li>
                  <a href="#" className={styles.footerLink}>
                    Help Center
                  </a>
                </li>
              </ul>
            </div>

            <div className={styles.footerSection}>
              <h4 className={styles.footerTitle}>For Professionals</h4>
              <ul className={styles.footerLinks}>
                <li>
                  <a href="#" className={styles.footerLink}>
                    Join Build Start
                  </a>
                </li>
                <li>
                  <a href="#" className={styles.footerLink}>
                    Business Dashboard
                  </a>
                </li>
                <li>
                  <a href="#" className={styles.footerLink}>
                    Success Stories
                  </a>
                </li>
                <li>
                  <a href="#" className={styles.footerLink}>
                    Support
                  </a>
                </li>
              </ul>
            </div>

            <div className={styles.footerSection}>
              <h4 className={styles.footerTitle}>Company</h4>
              <ul className={styles.footerLinks}>
                <li>
                  <a href="#" className={styles.footerLink}>
                    About Us
                  </a>
                </li>
                <li>
                  <a href="#" className={styles.footerLink}>
                    Careers
                  </a>
                </li>
                <li>
                  <a href="#" className={styles.footerLink}>
                    Press
                  </a>
                </li>
                <li>
                  <a href="#" className={styles.footerLink}>
                    Contact
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className={styles.footerBottom}>
            <p className={styles.footerCopyright}>© 2024 Build Start. All rights reserved.</p>
            <div className={styles.footerLegal}>
              <a href="#" className={styles.footerLegalLink}>
                Privacy Policy
              </a>
              <a href="#" className={styles.footerLegalLink}>
                Terms of Service
              </a>
              <a href="#" className={styles.footerLegalLink}>
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default HomeLandingPagePureCSS
